import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { RestService } from '../../service/rest.service';
import { FilterListFieldEntry } from '../model/filter-list-field-entry';
import { FilterListFieldType } from '../model/filter-list-field-type';

@Injectable()
export class FilterDataService extends RestService {

  constructor(http: HttpClient, private translate: TranslateService) {
    super(http);
  }

  fetchFilterListFieldAvailableValues(fieldType: FilterListFieldType): Observable<FilterListFieldEntry[]> {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const headers = new HttpHeaders({ 'Accept-Language': this.translate.currentLang });
    return this.getAndExtract<FilterListFieldEntry>(FilterListFieldEntry, `api/filters/listField/${fieldType}/values`, headers);
  }
}
